export default "__VITE_ASSET__jat$NSgn__"